import { CoachLampIcon } from './CoachLampIcon';

/**
 * author: Borre Haugen
 * id 113768A1-5B09-41DD-9570-31434A34823D
 * name coach-lamp
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coach-lamp.svg
 * tags
 * - Home Automation 
 */
export const CarriageLampIcon = CoachLampIcon;
export default CarriageLampIcon